import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/components/shared/api.service';
import { localStorageService } from 'src/app/components/shared/localstorage.service';
import { MainService } from 'src/app/components/shared/main.service';
import { SharedService, notBlankValidator } from 'src/app/components/shared/shared.service';
import { AssignmentsService } from '../assignments.service';
import { NgxSelectModule } from 'ngx-select-ex';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { environment } from 'src/environments/environment';
import { HttpEvent, HttpEventType, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { SharedModule } from 'src/app/components/shared/shared.module';

@Component({
  selector: 'app-assignments-modal',
  // standalone: true,
  // imports: [CommonModule, FormsModule, ReactiveFormsModule, BsDatepickerModule, NgxSelectModule, ProgressbarModule],
  templateUrl: './assignments-modal.component.html',
  styleUrl: './assignments-modal.component.scss'
})
export class AssignmentsModalComponent implements OnInit, OnDestroy {
  @ViewChild('imageElement') imgElement!: ElementRef;
  selectedRecord: any = 0;
  public assignToMeForm!: UntypedFormGroup;
  public deleteForm!: UntypedFormGroup;
  public phaseAssignToMeForm!: UntypedFormGroup;
  public approveForm!: UntypedFormGroup;
  public changeStatusForm!: UntypedFormGroup;
  public addNoteForm!: UntypedFormGroup;
  public updateForm!: UntypedFormGroup;
  public viewFullSSNForm!: UntypedFormGroup;
  public edit_alternates!: edit_alternates_modal;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  modalType = '';
  public extra_data!: modal_data;  
  public document_data!: document_data;
  public phase_extra_data!: phase_modal_data;
  public approve_extra_data!: approve_modal_data;
  public change_status_data!: change_status_data;
  public add_note_data!: add_note_data;
  public update_extra_data!: update_extra_data;
  country_code: any = 'US';
  assigned_to_id: any;
  admin_list = this._shared.getAdminList();
  hours = [{ value: "00" }, { value: "01" }, { value: "02" }, { value: "03" }, { value: "04" }, { value: "05" }, { value: "06" }, { value: "07" }, { value: "08" }, { value: "09" }, { value: "10" }, { value: "11" }, { value: "12" }, { value: "13" }, { value: "14" }, { value: "15" }, { value: "16" }, { value: "17" }, { value: "18" }, { value: "19" }, { value: "20" }, { value: "21" }, { value: "22" }, { value: "23" }];
  minutes = [{ value: "00" }, { value: "15" }, { value: "30" }, { value: "45" }];
  today = new Date();
  minDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate());
  only_assign_button: any;
  timezoneName: any;
  timezone = this._shared.getTimezone();
  dateConfig: any = {
    containerClass: 'theme-blue',
    placement: 'left',
    dateInputFormat: 'MM-DD-YYYY'
  };
  images: any = [];
  loadingZip: any = {
    loading: false,
    loadingError: false,
    data: []
  };
  zip: any = [];
  public mask: any = [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  isError: any = false;
  paramSub: any;
  uploaded_doc:any;
  remaining_doc:any;
  show_need_more_document:any = 1;  
  needMore : boolean = false;
  public reasons: any= [{reason_id:1,reason_value:'A discrepancy in service amount'},{reason_id:2,reason_value:'Documents are unclear or lack visibility'},{reason_id:3,reason_value:'Attached is the screenshot of the document, please upload the document in PDF form'},{reason_id:4,reason_value:'Documents lacking signatures Insufficient documents, requesting additional documents'},{reason_id:5,reason_value:'Requires credit report documentation prior to and after taking the service'}];
  note:any ="";
  business_uploaded_doc: any;

  constructor(
    public _main: MainService,
    private _api: ApiService,
    private _local: localStorageService,
    public _shared: SharedService,
    // private router: Router,
    // private route: ActivatedRoute,
    // private datePipe: DatePipe,
    public changeDetect: ChangeDetectorRef,
    private modalService: BsModalService,
    private _fb: FormBuilder,
    public bsModalRef: BsModalRef,
    public _assignmentsService: AssignmentsService,
    private datePipe: DatePipe,
    private _http: HttpClient,
    public _sanitizer: DomSanitizer,
    private _router: ActivatedRoute,
   
  ) {}

  ngOnInit(): void {
    // View SSN
     if (this.modalType == this._assignmentsService.modalTypes.viewFullSSN) {
          this.viewFullSSNForm = this._fb.group({
             notes: ['', Validators.required],
            password:  ['', Validators.required ],
          });
        }

    if (this.modalType == this._assignmentsService.modalTypes.assignToMeModal) {
      this.assignToMeForm = this._fb.group({
        notes: ['', [Validators.required, notBlankValidator()]],
        // disableEnable: [this.modalType == this._contract.modalTypes.bankruptcyModal ? this.extra_data.contract.bankrupt_stop_payment : 0, Validators.required]
      })
    }


    if (this.modalType == this._assignmentsService.modalTypes.deleteModal){
      this.deleteForm = this._fb.group({
        notes: ['', Validators.required]
      })
    }

    if (this.modalType == this._assignmentsService.modalTypes.ticketAssignToMeModal){
      this.phaseAssignToMeForm = this._fb.group({
        notes: ['', Validators.required],
        status: ['', Validators.required],
        followupDate: ['',Validators.required],
        followup_minutes: ['', Validators.required],
        followup_hour: ['', Validators.required]
      })
    }

    if (this.modalType == this._assignmentsService.modalTypes.approveRejectModal){
      this.approveForm = this._fb.group({
        notes: ['', Validators.required],
        admin_id: ['', Validators.required]
      })
    }

    if (this.modalType == this._assignmentsService.modalTypes.changeStatusModal){
      this.changeStatusForm = this._fb.group({
        notes: ['', Validators.required],
        admin_id: [''],
        followupDate: [this.minDate],
        followup_minutes: [''],
        followup_hour: [''],
        result_of_contact: [this.change_status_data.result_of_contact || ''],
        status: [this.change_status_data.status, Validators.required],
        type_of_call: [this.change_status_data.type_of_call || ''], // ticket's current type, changeable
      })

      this.changeStatusForm.controls['followupDate'].setValue(this.datePipe.transform(this.minDate, 'MM-dd-yyyy'));
    }

    if (this.modalType == this._assignmentsService.modalTypes.addNoteModal){
      this.addNoteForm = this._fb.group({
        notes: ['', Validators.required]
      })
    }

    if (this.modalType == this._assignmentsService.modalTypes.updateInformationInquiryModal){
      this.updateForm = this._fb.group({
        update_note: ['', Validators.required],
        wp_message: ['', Validators.required],
        wp_phone: [this.update_extra_data.assignment.wp_phone, Validators.required],
        wp_email: [this.update_extra_data.assignment.wp_email, Validators.required],
        wp_name: [this.update_extra_data.assignment.wp_name, Validators.required],
        wp_address: [this.update_extra_data.assignment.wp_address || '', Validators.required],
        wp_city_name: [this.update_extra_data.assignment.wp_city_name, Validators.required],
        wp_speciality: [this.update_extra_data.assignment.wp_speciality && this.update_extra_data.assignment.wp_speciality != 'N.A.' ? this.update_extra_data.assignment.wp_speciality : '', Validators.required],
        wp_distance: [this.update_extra_data.assignment.wp_distance, Validators.required],
        wp_state_name: [this.update_extra_data.assignment.wp_state_name, Validators.required],
        wp_zip: [this.update_extra_data.assignment.wp_zip, Validators.required]
      })
    }

    this.paramSub = this._router.queryParams.subscribe((params: any) => {
      this.timezone = params['timezone'];
      this.timezoneName = this._shared.getTimezoneList();
      this.timezoneName = this.timezoneName.filter((timezone: any) => timezone.val == this.timezone)[0].offset;
    })

    if (this.modalType == this._assignmentsService.modalTypes.viewDocuments){
      this.uploaded_doc = this.document_data.documents.uploaded_documents.filter((doc:any) => {
       return doc.document_name !=="Others"
      });
      this.remaining_doc = this.document_data.documents.remaining_documents.filter((doc:any) => {
       return doc.document_name != null
      });
      this.show_need_more_document = this.uploaded_doc.filter((doc:any) => {
       return doc.need_more_document == '1' ;
      });
      this.show_need_more_document = this.remaining_doc.length > 0 ?  this.remaining_doc.filter((doc:any) => {
       return doc.need_more_document == '1' ;
      }) : this.show_need_more_document;
 
      this.show_need_more_document = this.show_need_more_document.length == this.uploaded_doc.length ? 0 : 1
      console.log(this.show_need_more_document);
      
     }

     if (this.modalType == this._assignmentsService.modalTypes.businessDocs){
      this.business_uploaded_doc = this.document_data.documents;
     }
  }

  handleAssignToMe() {
    if (this.assignToMeForm.valid){
      console.log("selectedRec",this.selectedRecord, this.assignToMeForm.value);
      let admin_id = this._local.customGetItem('admin_profile')['admin_id'];
      console.log('admin_id--',admin_id);
      if(!admin_id){
        this._shared.customPopups('Admin id not found', 1);
        return false;
      }
      if(this.extra_data && this.extra_data.admin_id && this.extra_data.admin_id == admin_id){
        this._shared.customPopups('Already assigned to you', 1);
        return false;
      } 
      console.log('extra data', this.extra_data);
      let params = {
        notes: this.assignToMeForm.value.notes,
        req_id: this.extra_data.req_id,
        assigned_id: admin_id,
        request_type: this.extra_data.request_type
      };
      this._api.api(params, 'assignments/assign_to_me')
        .subscribe((data: any) => {
          if (data.is_error == 0) {
            // modal.hide();
            this.assignToMeForm.reset();
            this.hide();
            this.passEntry.emit({success: true});
            this._shared.customPopups('Ticket assigned to me successfully.', 0);
          }
        }, (error: any) => {
          console.log(error);
        })
        return true;
    }
    return true;
  }

  hide() {
    this.bsModalRef.hide()
  }

  cancel() {
    this.passEntry.emit({success: false});
    this.hide();
  }

  handleDelete() {
    if (this.deleteForm.valid) {
      let params = {
        notes: this.deleteForm.value.notes,
        req_id: this.extra_data.req_id,
        request_type: this.extra_data.request_type
      };
      this._api.api(params, 'assignments/delete_csr_request')
        .subscribe((data: any) => {
          if (data.is_error == 0) {
            this.deleteForm.reset();
            this.hide();
            this.passEntry.emit({success: true});
            this._shared.customPopups('Ticket deleted successfully.', 0);
          }
        }, (error: any) => {
          console.log(error);
        })
    }

  }

  selectAssignedAdmin(event: any) {
    this.assigned_to_id = event;
    if (this.approveForm){
      this.approveForm.controls['admin_id'].setValue(event);
    }
    if (this.changeStatusForm){
      this.changeStatusForm.controls['admin_id'].setValue(event);
    }
    // this.approveForm.value.admin_id = event;
    // this.changeStatusForm.value.admin_id = event;
  }

  assignedAdminClear(event: any) {
    if (event.length == 0) {
      this.assigned_to_id = 0;
      this.approveForm.value.admin_id = 0;
      this.changeStatusForm.value.admin_id = 0;
    }
  }

  assignTicket() {
    let admin_id = this.assigned_to_id ? this.assigned_to_id : this._local.customGetItem('admin_profile')['admin_id'];
    if (!admin_id) {
      this._shared.customPopups('Admin id not found', 1);
      return false;
    }
    if ((!this.phaseAssignToMeForm.value.followup_hour || !this.phaseAssignToMeForm.value.followup_minutes) && this.phaseAssignToMeForm.value.status != 1 && !this.only_assign_button) {
      this._shared.customPopups('Please select a valid followup time', 2)
      return false;
    }
    // if (this.selectedRecord && this.selectedRecord.req_id) {
    //   this.selectedAssignments.push(this.selectedRecord.req_id)
    // }
    let params = {
      notes: this.phaseAssignToMeForm.value.notes,
      req_id: this.phase_extra_data.req_id,
      assigned_id: admin_id,
      status: this.phaseAssignToMeForm.value.status,
      followup_date: this.phaseAssignToMeForm.value.followupDate,
      bulk_assign: 0
    };
    if (this.only_assign_button) {
      params.bulk_assign = 1;
    }

    if (this.phaseAssignToMeForm.value.followupDate) {
      let followup_date = this.datePipe.transform(this.phaseAssignToMeForm.value.followupDate, 'yyyy-MM-dd');
      if (this.phaseAssignToMeForm.value.followup_hour && this.phaseAssignToMeForm.value.followup_minutes) {
        let time = new Date().getTimezoneOffset();
        let hours = Math.abs(Math.trunc(time / 60));
        let minutes = ("0" + time % 60).slice(-2);
        let user_timezone = '';
        if (time > 0) {
          user_timezone = "-" + hours + minutes;
        } else {
          user_timezone = "+" + hours + minutes;
        }
        let today_time = this._shared.getfollowupDateTimeInUTCToday(new Date(), user_timezone)
        let today_time_1 = new Date(today_time).getTime();
        let follow_up = this._shared.getfollowupDateTimeInUTC(followup_date + ` ${this.phaseAssignToMeForm.value.followup_hour}:${this.phaseAssignToMeForm.value.followup_minutes}:00`, this.timezone)
        let follow_up_time = new Date(follow_up).getTime();
        if (this.phase_extra_data.req_id.length > 1) {
          if (today_time_1 >= follow_up_time && this.phaseAssignToMeForm.value.status != 1) {
            this._shared.customPopups('Please select future time for followup', 2);
            delete params.req_id;
            return false;
          } else {
            params.followup_date = follow_up;
          }
        } else {
          if (today_time_1 >= follow_up_time && this.phaseAssignToMeForm.value.status != 1) {
            this._shared.customPopups('Please select future time for followup', 2);
            // this.selectedAssignments = [];
            return false;
          } else {
            params.followup_date = follow_up;
          }
        }
      }
    }
    this._api.api(params, 'assignments/assign_internal_ticket')
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.phaseAssignToMeForm.reset();
          this.hide();
          this.passEntry.emit({success: true});
          this._shared.customPopups('Ticket assigned successfully.', 0);
        }
      }, (error: any) => {
        console.log(error);
      })
      return true;
  }

  handleApproveReject() {
    let params = {
        notes: this.approveForm.value.notes,
        req_id: this.approve_extra_data.req_id,
        is_approved: this.approve_extra_data.is_approved,
        admin_id: this.approveForm.value.admin_id
    };
    this._api.api(params, 'assignments/approve_disapprove_csr_request')
        .subscribe((data: any) => {
            if (data.is_error == 0 || !data.is_error) {
              this.approveForm.reset();
              this.hide();
              this.passEntry.emit({success: true});
                // this.notes.unshift({
                //     note: params.notes,
                //     date_added: new Date(),
                //     admin_name: this._local.customGetItem('admin_profile').admin_name
                // })
            }
        }, (error: any) => {
            console.log(error);
        })

  }

  cancelImageUpload(file: any, index: any) {
    this.change_status_data.images[index].uploadSub.unsubscribe();
    this.change_status_data.images[index].uploading = false;
    this.change_status_data.images.every((item: any) => {
        this.change_status_data = item.uploading
    });
    this.change_status_data.images.splice(index, 1);
  }

  deleteFile(file: any, index: any) {
    this.images.splice(index, 1);
        // this._api.deleteServerFile(file, 'user/delete_hard_request_doc')
        //     .subscribe((data: any) => {
        //         if (data && data.is_error == 0) {
                   
        //         }
        //     })
  }

  fileSelect(event: any) {
    if (this.images && this.images.length > 10) {
        this._shared.customPopups('Can not upload more than 10 files', 2);
        return false;
    }
    if (event && event.target && event.target.files && event.target.files.length > 0) {
        for (let file of event.target.files) {
            let selectedFile = { file: file };
            if ((selectedFile.file.size / 1024 / 1024) > 10) {
                this._shared.customPopups('File size must be less than 10MB', 2);
                return false;
            }
            if (selectedFile.file.type.indexOf('image/') === 0 || selectedFile.file.type.indexOf('application/') === 0) {
                let index = this.images.findIndex((x: any) => x.file.mediaFile.name == selectedFile.file.name);
                const reader = this.readFiles(selectedFile);
                if (index < 0) {
                    this.images.push({ file: reader });
                    this.change_status_data.uploading = true;
                    this.uploadFile(reader, this.images.length - 1);
                    this.imgElement.nativeElement.value = '';
                }
            } else {
                this._shared.customPopups('Please select valid file', 2);
            }
        }
    }
    return true;
  }

  readFiles(file: any) {
    file.mediaFile = file.file;
    file.file = this._sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file.mediaFile));
    return file;
  }


  uploadFile(item: any, index?: any) {
    this.change_status_data.uploading = true;
    this.images[index].uploading = true;
    const formData = new FormData();
    formData.append('file', item.mediaFile);
    this.images[index].uploadSub = this._http.post(environment.baseUrl + 'assignments/upload_csr_doc', formData, {
        reportProgress: true,
        observe: 'events'
    })
        .pipe(
            map((event: HttpEvent<any>) => {
                let response: any = [];
                if (event.type === HttpEventType.UploadProgress) {
                    const percentDone = Math.round(100 * event.loaded / (event.total || 1));
                    response = [{ status: 'progress', message: percentDone }];
                }
                if (event.type === HttpEventType.Response) {
                    response.push(event.body);
                }
                return response;
            })
        )
        .subscribe(d => {
            if (this.images && this.images[index]) {
                this.images[index].subs = d;
            }
            this.change_status_data.fileSubscription = d;
            let success = d.every((item: any) => {
                return item.status !== 'progress'
            });
            if (success) {
                this.change_status_data.uploading = false;
                this.images[index].uploading = false;
                d.forEach((item: any) => {
                    this.change_status_data.imageURLs.push(item.images[0]);
                    this.images[index].image = item.images[0];
                })

            } else {
                this.change_status_data.uploading = true;
                this.images[index].uploading = true;
            }
        });
  }

  updateField(key: any, value: any) {
    this.change_status_data[key] = Number(value.target.value);
    if (key === 'type_of_call') {
        if ([6, 7, 8].includes(+value)) {
            this.change_status_data['result_of_contact'] = '';
        }
        const result_of_contact =  this.change_status_data.allResultTypeArr.filter((result: any) => result.contact_id == Number(value.target.value))[0];
        this.change_status_data.result_of_contact_arr = result_of_contact && result_of_contact.contact_data;
        if (!this.change_status_data['result_of_contact'] || value === 9) {
            this.change_status_data['result_of_contact'] = this.change_status_data.result_of_contact_arr[0].result_id;
        }
    }
  }

  changeStatus() {
    if (this.changeStatusForm.value.notes && !this.changeStatusForm.value.notes.trim().length) {
      this._shared.customPopups('Please enter a valid note.', 2);
      return;
    }
    const data: any = {
      req_id: this.change_status_data.req_id,
      notes: this.changeStatusForm.value.notes,
      status: this.changeStatusForm.value.status,
      contact_type: this.changeStatusForm.value.type_of_call,
      contact_result: this.changeStatusForm.value.result_of_contact,
      followup_hour: this.changeStatusForm.value.followup_hour,
      followup_minutes: this.changeStatusForm.value.followup_minutes,
      followup_date: this.changeStatusForm.value.followupDate? moment(this.changeStatusForm.value.followupDate).format('YYYY-MM-DD') : moment(this.today).format('YYYY-MM-DD'),
      request_type: this.change_status_data.api_request_type ? this.change_status_data.api_request_type : 'admin_assignment'
    };
    if (this.changeStatusForm.value.admin_id){
      data['admin_id'] = this.changeStatusForm.value.admin_id;
    }
    if (this.changeStatusForm.value.status != 3 && this.changeStatusForm.value.status == this.change_status_data.assignment_status && !this.changeStatusForm.value.admin_id) {
        this._shared.customPopups('Please select a new status or a CSR to re-assign', 2)
        this.changeDetect.detectChanges();
        console.log('error')
        return false;
    }
    if ((!this.changeStatusForm.value.followup_hour || !this.changeStatusForm.value.followup_minutes) && this.changeStatusForm.value.status != 1) {
        this._shared.customPopups('Please select a valid followup time', 2)
        return false;
    }
    if (this.changeStatusForm.value.followupDate && this.changeStatusForm.value.status == 3) {
        let followup_date = this.datePipe.transform(this.changeStatusForm.value.followupDate, 'yyyy-MM-dd');
        if (this.changeStatusForm.value.followup_hour && this.changeStatusForm.value.followup_minutes) {
            let time = new Date().getTimezoneOffset();
            let hours = Math.abs(Math.trunc(time / 60));
            let minutes = ("0" + time % 60).slice(-2);
            let user_timezone = '';
            if (time > 0) {
                user_timezone = "-" + hours + minutes;
            } else {
                user_timezone = "+" + hours + minutes;
            }
            let today_time = this._shared.getfollowupDateTimeInUTCToday(new Date(), user_timezone)
            let today_time_1 = new Date(today_time).getTime();
            let follow_up = this._shared.getfollowupDateTimeInUTC(followup_date + ` ${this.changeStatusForm.value.followup_hour}:${this.changeStatusForm.value.followup_minutes}:00`, this.timezone)
            data.followup_date = follow_up;
            let follow_up_time = new Date(follow_up).getTime();
            if (today_time_1 >= follow_up_time) {
                this._shared.customPopups('Please select future time for followup', 2);
                return false;
            } else {
                this.changeStatusForm.value.followupDate = follow_up;
            }
        }
    }
    if (this.images && this.images.length > 0) {
        data['docs_urls'] = this.images.map((x: any) => x.image);
    }
    if (this.change_status_data.uploading) {
        this._shared.customPopups('Please wait while files are uploading', 2);
        return false;
    }
    if (this.changeStatusForm.value.status == 1) {
        delete data.followup_date;
        delete data.followup_hour;
        delete data.followup_minutes;
        delete data.admin_id;
        delete data.contact_type;
        delete data.contact_result;
        // delete data.docs_urls;
    }
    this._api.api(data, 'assignments/change_and_reassign_csr_request_status')
        .subscribe((data: any) => {
            this.changeStatusForm.reset();
            this.hide();
            this.passEntry.emit({success: true});
        }, (error: any) => {
            console.log(error);
        })
        return true;
  }

  addNote() {
    let dataParams: any = {
        notes: this.addNoteForm.value.notes,
        req_id: this.change_status_data.req_id
    };

    if (this.images && this.images.length > 0) {
        dataParams['docs_urls'] = this.images.map((x: any) => x.subs[0].images[0]);
    }
    if (this.change_status_data.uploading) {
        this._shared.customPopups('Please wait while files are uploading', 2);
        return false;
    }
    this._api.api(dataParams, 'assignments/add_csr_request_notes')
        .subscribe((data: any) => {
            if (data.is_error == 0) {
              this.addNoteForm.reset();
              this.hide();
              this.passEntry.emit({success: true});
            }
        }, (error: any) => {
            console.log(error);
        })
        return true;
  }

  fetchZipList(event: any) {
        if (event.length > 3) {
            this.loadingZip.loading = true;
            const data: any = {
              zipCode: event,
              country_id: 1
            }
            this._api.api(data, environment.baseUrl + '/get_zipcodes')
                .subscribe((data: any) => {
                    this.zip = data.zip_info;
                    if (data.zip_info && data.zip_info.length) {
                        this.loadingZip.data = data.zip_info;
                    }
                    this.loadingZip.loading = false;
                    this.loadingZip.error = false;
                }, (error: any) => {
                    this.loadingZip.loading = false;
                    this.loadingZip.error = true;
                    console.log(error);
                })
        }
    }

    zipClear(event: any) {
      if (event.length == 0) {
          this.loadingZip.data = [];
      }
  }

  selectZip(e: any): void {
    var getZipData = this.loadingZip.data.filter((singleItem: any) => {
        return singleItem.zip == e;
    })
    if (getZipData) {
      this.updateForm.controls['wp_zip'].setValue(getZipData[0].zip);
      this.updateForm.controls['wp_state_name'].setValue(getZipData[0].state_name);
      this.updateForm.controls['wp_city_name'].setValue(getZipData[0].city);
      this.updateForm.controls['city_id'].setValue(getZipData[0].city_id);
    }
  }

  updateInquiry() {
        if (!this.updateForm.value.wp_city_name || this.updateForm.value.wp_city_name == null) {
            this.isError = true;
            return false
        } else {
            let updateData = {
                                req_id: this.update_extra_data.req_id,
                                query_id: this.update_extra_data.wp_query_id,
                                wp_name: this.updateForm.value.wp_name,
                                wp_email: this.updateForm.value.wp_email,
                                wp_phone: this.updateForm.value.wp_phone,
                                wp_speciality: this.updateForm.value.wp_speciality,
                                wp_address: this.updateForm.value.wp_address,
                                wp_city_id: this.updateForm.value.city_id,
                                wp_distance: this.updateForm.value.wp_distance,
                                wp_state_name: this.updateForm.value.wp_state_name,
                                wp_state: this.updateForm.value.wp_state_name,
                                wp_zip: this.updateForm.value.wp_zip,
                                notes: this.updateForm.value.wp_message,
                                update_notes: this.updateForm.value.update_note,
                                wp_city: this.updateForm.value.wp_city_name
                            }

                            this._api.api(updateData, 'assignments/update_csr_inquiry_request')
                                .subscribe((data: any) => {
                                    if (data.is_error == 0) {
                                        this.isError = false;
                                        this.updateForm.reset();
                                        this.hide();
                                        this.passEntry.emit({success: true});
                                    }
                                }, (error: any) => {
                                    console.log(error);
                                })


        }
        return true;
    }

    changeToggle (event: any) {
      this.only_assign_button = (event.target as HTMLInputElement).checked;
      console.log("assign button value: " + this.only_assign_button);
    }
    // View SSN Modal 
    viewFullSSN() {
    let data: any = {
      password: this.viewFullSSNForm.value.password,
      split_req_id: this.edit_alternates.split_req_id,
      notes: this.viewFullSSNForm.value.notes,
      ticket_id:this.edit_alternates.ticket_id,
      
    };
    this._api.api(data, 'finance/view_full_ssn')
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.passEntry.emit({ success: true, patient_ssn: data.full_ssn && data.full_ssn[0].patient_ssn });
          this.hide();
          return;
        } else if (data.is_error == 1) {
          if (data.original_text) {
            this._shared.customPopups(data.original_text, data.is_error);
          } else {
            this._shared.customPopups(data.flag, data.is_error);
          }
        }
      });
  } 

    ngOnDestroy(): void {
      if(this.paramSub) {
        this.paramSub.unsubscribe();
      }
    }

    selectedReason(reason_index:any, document_index:any,from:any){
      this.uploaded_doc[document_index].reason = this.reasons[reason_index].reason_value 
          
    }
    toggleSelect(document_index: any, from: any) {
      if (from == 1) {
        this.uploaded_doc[document_index].selected = !(this.uploaded_doc[document_index].selected)
        this.uploaded_doc[document_index].reason = ""
      } else {
        this.remaining_doc[document_index].selected = !(this.remaining_doc[document_index].selected)
        this.remaining_doc[document_index].reason = ""
      }
  
    }

    approveOrNeedMoreDocument(req_type : any){
      this.note = this.note.trim();
      if (req_type == 1 && (!this.note || this.note == ' ')){
        this._shared.customPopups('Please enter a valid note.', 1);
        return;
      }
      let param = {
        document_ids: this.uploaded_doc.filter((item: any) => { return item.selected == true }),
        remaining_documents: this.remaining_doc.filter((item: any) => { return item.selected == true }),
        note : this.note,
        req_type
      }

    let send_data = {
      req_id: (this.document_data.assignment_detail.req_id).toString(),
      request_type: req_type,
      document_ids: this.uploaded_doc.filter((item: any) => { return item.selected == true }),
      remaining_documents: this.remaining_doc.filter((item: any) => { return item.selected == true }),
      note: this.note,
    }
    this._api.api(send_data, 'assignments/dispute_documents_action', 'post').subscribe({
      next: (data) => {
        if (data && !data.is_error) {
          this.hide();
          this.passEntry.emit({ success: true, data: param });
        }
      },
      error: () => { }
    });

  }

    submitDocuments() {
      this.note = this.note.trim();
      if (!this.note || this.note == ' '){
        this._shared.customPopups('Please enter a valid note.', 1);
        return;
      }
      const params = {
        contract_id: this.document_data.assignment_detail.contract_id,
        note: this.note,
        doctor_id : this.document_data.assignment_detail.doctor_id,
        split_req_id :  this.document_data.assignment_detail.split_req_id
      };

      if ( this.document_data.assignment_detail.is_arv2) {
        delete params.contract_id
      }else{
        delete params.split_req_id
      }
      this._api
        .api(params, 'assignments/submit_documents')
        .subscribe((data: any) => {
          if (data && !data.is_error) {
            setTimeout(()=>{
              this.hide();
              this.passEntry.emit({ success: true });
             
            },2000);
            this._shared.customPopups('Documents submitted, reassigned to admin.', 3);        
           
          }
        });
    }

    disSelectALL(){
      this.uploaded_doc.map((doc : any)=>{
          doc.selected = !doc.selected
      })
    }
}

interface modal_data {
  req_id: any,
  request_type: any,
  admin_id?: any
}

interface phase_modal_data {
  req_id: any,
  status: any,
  followup_date: any,
  followup_hour: any,
  followup_minutes: any
}

interface approve_modal_data {
  req_id: any,
  is_approved: any,
  debt_written_off?: any,
  debt_charge_off?: any,
  debt_canceled?: any
}

interface change_status_data {
  req_id?: any,
  followup_date?: any,
  status?: any,
  uploading?: any,
  images?: any,
  fileSubscription?: any,
  imageURLs?: any,
  result_of_contact_arr?: any,
  type_of_call?: any,
  result_of_contact?: any,
  allResultTypeArr?: any,
  type_of_call_arr?: any,
  role?: any,
  phase_req_id?: any,
  api_request_type?: any,
  assignment_status?: any,
  [key: string]: any; // Index signature to allow other properties
  action_type?: any
}

interface add_note_data {
  req_id: any,
  uploading: any,
}

interface update_extra_data {
  req_id: any,
  wp_zip?: any,
  industries?: any,
  wp_query_id?: any,
  assignment?: any
}

interface document_data {
  documents?: any,
  assignment_detail? :any
  wp_query_id?: any,
  assignment?: any
}
interface edit_alternates_modal {
  ticket_id:number;
  split_req_id: number
  dobData?: any,
  ssnData?: any,
  contract_patient_token?: any
  showCheckbox?:boolean
  splitData?:any
}